import { FilterBase } from './filter-base.js';

/**
 * Text input filter component.
 * Provides a simple text input for filtering.
 * @class
 * @extends {FilterBase}
 */
class FilterText extends FilterBase {
    /**
     * Initialize the text filter component.
     * @constructor
     */
    constructor() {
        super();
        /** @type {HTMLInputElement|null} The text input element */
        this.inputElement = null;
    }

    /**
     * Renders the text input filter component.
     * Creates a text input field with appropriate attributes.
     */
    render() {
        super.render(); // Call base render to clear content

        if (!this.filterData) return;

        // Add the text input specific to this filter type
        this.inputElement = document.createElement('input');
        this.inputElement.type = 'text';
        this.inputElement.id = `filter-input-${this.filterData.name}`; // For label association
        this.inputElement.name = this.filterData.name;
        this.inputElement.placeholder = `Enter ${this.filterData.label}...`;

        this.appendChild(this.inputElement);
    }

    /**
     * Gets the current value of the text input.
     * @returns {string|null} The current input value or null if no input exists
     */
    getValue() {
        return this.inputElement ? this.inputElement.value : null;
    }
}

customElements.define('filter-text', FilterText);
